exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".language-selector{margin:0 0 0 -15px;padding:0;list-style:none;float:left;height:40px;line-height:40px}.language-selector__dropdown{color:#fff;opacity:.5}.language-selector__dropdown:hover{color:#fff;opacity:1}.icon-earth{display:inline-block}.icon-earth svg{vertical-align:middle;margin-right:10px;height:20px;width:20px}.icon-earth #continents{animation:2s earth-rotate linear infinite forwards paused}.icon-earth:hover #continents{animation-play-state:running}.language-selector__item{display:block;height:30px;line-height:30px}.divider{margin:4px 0!important}.language-selector .open .dropdown-menu{top:auto;bottom:100%}@keyframes earth-rotate{0%{transform:matrix(1,0,0,1,-43,0)}to{transform:matrix(1,0,0,1,0,0)}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/Footer/LanguageMenu/style.css
 ** module id = 2002
 ** module chunks = 73
 **/